import React from "react";
import { AiOutlineEdit } from "react-icons/ai";
import { RiDeleteBin6Line } from "react-icons/ri";
import { useCurrent } from "../../../hooks";
import { getLangText } from "../../../utils/global";

const ListGroupsItem = ({ item, editHandeler, deleteHandeler }) => {
  const { currentLangId } = useCurrent();
  return (
    <div className="flex justify-between items-center gap-4 border-t p-2  hover:bg-indigo-50 hover:font-bold">
      <div className="flex-1">{getLangText(item?.groupName, currentLangId)}</div>
      <div
        className="w-4 text-center text-indigo-400 cursor-default hover:text-indigo-800"
        onClick={() => editHandeler(item._id)}
      >
        <AiOutlineEdit size={18} />
      </div>
      <div
        className="w-4 text-center text-indigo-400 cursor-default hover:text-indigo-800"
        onClick={() => deleteHandeler(item._id)}
      >
        <RiDeleteBin6Line size={18} />
      </div>
    </div>
  );
};

export default ListGroupsItem;

